import { getAnalytics, logEvent as firebaseLogEvent } from 'firebase/analytics';

//Firebase Events

//Airspace
export const GET_LAANC = 'get_laanc'; // "LAANC" Button on airspace clicked
export const CARD_EXPANDED = 'card_expand'; // Expanded the details of an Advisory card (more button)
export const CARD_COLLAPSED = 'card_collapse'; // Collapse the details of an Advisory card (less button)
export const AIRSPACE_AIRSPACE_TAB_TAPPED = 'airspace_airspaceTab_tapped';

export const AIRSPACE_SEARCH_ADDRESS = 'airspace_search_address';

export const AIRSPACE_WEATHER_TAB_TAPPED = 'airspace_weatherTab_tapped';
export const AIRSPACE_CREATE_CUSTOM_LAYER = 'airspace_create_custom_layer';
export const AIRSPACE_CREATE_MISSION = 'airspace_create_mission';

//Map
// If a Pin is dropped at a location based on GPS
export const PIN_DROP_TAP = 'pin_drop_tap'; // Tap to Drop Pin
export const PIN_DROP_SEARCH = 'pin_drop_search'; // If a Pin is dropped at a location based on a search result or search lat/long
export const MAP_SETTINGS_OPEN = 'map_settings_open'; // User opens the map settings popup
export const MAP_SETTINGS_CLOSE = 'map_settings_close'; // User closed the map settings popup
//Map styles are tracked in MapStyleOptions

//Workflow
export const SELECTABLE_WORKFLOW_STEP_SAVED = 'selectable_workflow_step_saved';

//General
export const OPEN = 'open'; // Application is opened
//menu_click_{name} is tracked in SideMenu

//Flight
export const FLIGHT_MERGE = 'flight_merge';
export const UNDO_FLIGHT_MERGE = 'undo_flight_merge';

export const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

let analytics;
export const initializeFirebaseLogger = firebaseApp => {
	analytics = getAnalytics(firebaseApp);
	firebaseLogEvent(analytics, OPEN);
};

export const logEvent = name => {
	firebaseLogEvent(analytics, name);
};

export const createOpenEvent = name => {
	return `${name.toLowerCase()}_open_create`; // User opens create view
};

export const createSubmitEvent = name => {
	return `${name.toLowerCase()}_submit_create`; //User successfully creates
};

export const editOpenEvent = name => {
	return `${name.toLowerCase()}_open_edit`; //User opens edit view
};

export const updateSubmitEvent = name => {
	return `${name.toLowerCase()}_submit_update`; //User successfully updates
};

export const deleteEvent = name => {
	return `${name.toLowerCase()}_delete`; //User successfully deletes
};

export const viewEvent = name => {
	return `${name.toLowerCase()}_view`;
};

export const searchEvent = name => {
	return `${name.toLowerCase()}_search`;
};

export const downloadEvent = name => {
	return `${name.toLowerCase()}_download`;
};

export const fileUploadEvent = name => {
	return `${name.toLowerCase()}_file_upload`;
};

export const fileDeleteEvent = name => {
	return `${name.toLowerCase()}_file_delete`;
};
